"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInsideUserRoster = exports.mergeRooms = exports.updateRoster = void 0;
var any_1 = require("../utils/any");
var immutable_1 = require("../utils/immutable");
function updateRoster(data, oldRooms, mentionsMultiMap) {
    var rooms = oldRooms;
    var monologRoomId;
    (data.rooms || []).forEach(function (room) {
        rooms = immutable_1.orderedMapUpdate(rooms, room.id, notSetRoom(), function (old) {
            if (room.type === "monolog") {
                monologRoomId = room.id;
            }
            var newRoom = mergeRoom(room, old);
            if (mentionsMultiMap && newRoom.userId && newRoom.display_name) {
                mentionsMultiMap.Add(newRoom.display_name, newRoom.userId);
            }
            return newRoom;
        });
    });
    (data.remove_room_ids || []).forEach(function (id) {
        rooms = rooms.delete(id);
    });
    return { rooms: rooms, monologRoomId: monologRoomId };
}
exports.updateRoster = updateRoster;
function notSetRoom() {
    return {
        id: undefined,
        type: undefined,
        name: undefined,
        display_name: undefined,
        createdTs: undefined,
        sip_uri: undefined,
        avatarUrl: undefined,
        userId: undefined,
        badge: undefined,
        summary_user: undefined,
        summary: undefined,
        interaction_ts: undefined,
        default: undefined,
        dialog_id: undefined,
        dialog_disabled: undefined,
        dialog_external_login_id: undefined,
        dialog_cti_states: undefined,
        monolog_id: undefined,
        userEmail: undefined,
        userPhoneNumber: undefined,
        userDepartment: undefined,
        userJobTitle: undefined,
        userLocation: undefined,
        userLastSeen: undefined,
        forum_id: undefined,
        forum_level: undefined,
        forum_creator: undefined,
        forum_access: undefined,
        contact_id: undefined,
        contact_extension_number: undefined,
        contact_public_number: undefined,
        mention_collisions: undefined,
    };
}
function mergeRoom(room, old) {
    var oldType = old.type, oldUri = old.sip_uri, oldName = old.name;
    var name = room.name;
    var uri;
    if (room.forum) {
        uri = room.forum.sip_uri;
    }
    else if (room.dialog) {
        uri = room.dialog.sip_uri;
    }
    else if (room.monolog) {
        uri = room.monolog.sip_uri;
    }
    else if (room.contact) {
        uri = room.contact.sip_uri;
    }
    var newRoom = {
        id: room.id,
        type: any_1.assign(oldType, room.type),
        name: name || oldName,
        display_name: name || oldName,
        createdTs: any_1.assign(old.createdTs, room.created_ts),
        interaction_ts: any_1.assign(old.interaction_ts, room.interaction_ts),
        sip_uri: uri || oldUri,
        avatarUrl: any_1.assign(old.avatarUrl, (room.dialog && room.dialog.avatar_url) || (room.monolog && room.monolog.avatar_url)),
        userId: any_1.assign(old.userId, (room.dialog && room.dialog.id) || (room.monolog && room.monolog.id)),
        userPhoneNumber: any_1.assign(old.userPhoneNumber, (room.dialog && room.dialog.phone_number) || (room.monolog && room.monolog.phone_number)),
        userDepartment: any_1.assign(old.userDepartment, (room.dialog && room.dialog.department) || (room.monolog && room.monolog.department)),
        userJobTitle: any_1.assign(old.userJobTitle, (room.dialog && room.dialog.job_title) || (room.monolog && room.monolog.job_title)),
        userLocation: any_1.assign(old.userLocation, (room.dialog && room.dialog.location) || (room.monolog && room.monolog.location)),
        userEmail: any_1.assign(old.userEmail, (room.dialog && room.dialog.email) || (room.monolog && room.monolog.email)),
        userLastSeen: any_1.assign(old.userLastSeen, (room.dialog && room.dialog.last_seen) || (room.monolog && room.monolog.last_seen)),
        badge: any_1.assign(old.badge, room.badge),
        summary_user: any_1.assign(old.summary_user, room.summary_user),
        summary: any_1.assign(old.summary, room.summary),
        default: any_1.assign(old.default, room.default),
        dialog_id: any_1.assign(old.dialog_id, room.dialog && room.dialog.id),
        dialog_disabled: any_1.assign(old.dialog_disabled, room.dialog && room.dialog.disabled),
        dialog_external_login_id: any_1.assign(old.dialog_external_login_id, room.dialog && room.dialog.external_login_id),
        dialog_cti_states: any_1.assign(old.dialog_cti_states, room.dialog && room.dialog.cti_states),
        monolog_id: any_1.assign(old.monolog_id, room.monolog && room.monolog.id),
        forum_id: any_1.assign(old.forum_id, room.forum && room.forum.id),
        forum_level: any_1.assign(old.forum_level, room.forum && room.forum.level),
        forum_creator: any_1.assign(old.forum_creator, room.forum && room.forum.creator && __assign({}, room.forum.creator)),
        forum_access: any_1.assign(old.forum_access, room.forum && room.forum.access && __assign({}, room.forum.access)),
        contact_id: any_1.assign(old.contact_id, room.contact && room.contact.id),
        contact_extension_number: any_1.assign(old.contact_extension_number, room.contact && room.contact.extension_number),
        contact_public_number: any_1.assign(old.contact_public_number, room.contact && room.contact.public_number),
        mention_collisions: any_1.assign(old.mention_collisions, room.mention_collisions),
    };
    return newRoom;
}
function mergeRooms(rooms) {
    var empty = notSetRoom();
    return rooms.map(function (room) { return [room.id, mergeRoom(room, empty)]; });
}
exports.mergeRooms = mergeRooms;
function isInsideUserRoster(r) {
    var room = r;
    var forumLevel = room.forum_level || (room.forum && room.forum.level);
    return !!(room.interaction_ts ||
        forumLevel === "follow" ||
        (room.badge && room.badge.count) ||
        room.type === "monolog" ||
        room.default);
}
exports.isInsideUserRoster = isInsideUserRoster;
